import { action, reaction, runInAction } from "mobx";
import { useEffect } from "react";
import { addToArrayIfNew, removeFromArray } from "../utils/array.utils";
import { useStore } from "../utils/mobx.utils";
import { last } from "../utils/ramdaEquivalents.utils";
import { useControllers } from "./controller.hooks";
import { useOnMount } from "./lifecycle.hooks";
export var useMakeFocusable = function (ref, handle) {
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        lastElement: null,
        ref: ref,
        get isLastFocused() {
            return last(UI.portalFocusableElementStack) === s.ref.current;
        },
        handleFocus: function () {
            UI.focusOnElementInPortal(s.ref.current);
        },
    }); });
    useEffect(function () {
        runInAction(function () {
            s.ref = ref;
        });
    });
    useOnMount(function () {
        var disposers = [];
        var documentListener = function (e) {
            if (!e.target || !handle)
                return;
            var didClickedOnHandle = e.target.closest(handle);
            if (didClickedOnHandle) {
                s.handleFocus();
            }
        };
        if (handle) {
            document.addEventListener('click', documentListener);
            disposers.push(function () {
                document.removeEventListener('click', documentListener);
            });
        }
        disposers.push(reaction(function () { return s.ref.current; }, action(function (current, prev) {
            if (prev) {
                removeFromArray(UI.portalFocusableElementStack, prev);
                if (!handle)
                    prev === null || prev === void 0 ? void 0 : prev.removeEventListener('focus', s.handleFocus);
            }
            if (current && current !== s.lastElement) {
                s.lastElement = current;
                addToArrayIfNew(UI.portalFocusableElementStack, current);
                if (!handle)
                    current.addEventListener('focus', s.handleFocus, { capture: true });
            }
        }), { fireImmediately: true }));
        disposers.push(reaction(function () { return s.isLastFocused; }, function (value) {
            var _a, _b;
            if (value)
                (_a = s.ref.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('z-index', '10010');
            else
                (_b = s.ref.current) === null || _b === void 0 ? void 0 : _b.style.removeProperty('z-index');
        }, { fireImmediately: true }));
        return function () {
            disposers.forEach(function (d) { return d(); });
            if (!handle)
                removeFromArray(UI.portalFocusableElementStack, s.lastElement);
        };
    });
    return s;
};
